import { render, staticRenderFns } from "./PeriodsComparisonWidget.vue?vue&type=template&id=0fd3d68d"
import script from "./PeriodsComparisonWidget.vue?vue&type=script&lang=js"
export * from "./PeriodsComparisonWidget.vue?vue&type=script&lang=js"
import style0 from "./PeriodsComparisonWidget.vue?vue&type=style&index=0&id=0fd3d68d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports